import {MainMenu} from '../../common/types/components';
import {Action} from '../../common/types/common';

export const ON_CLICK_MAIN_MENU_ITEM: Action = {
    name: 'ON_CLICK_MAIN_MENU_ITEM',
    action: (item: MainMenu) => ({
        item,
        type: ON_CLICK_MAIN_MENU_ITEM.name
    })
};

export const ON_CLICK_MAIN_MENU_ITEM_USER: Action = {
    name: 'ON_CLICK_MAIN_MENU_ITEM_USER',
    action: (item: MainMenu) => ({
        item,
        type: ON_CLICK_MAIN_MENU_ITEM_USER.name
    })
};

// Dispatched when the current route (not a click) determines which menu item should be
// highlighted/expanded — e.g. on direct navigation, refresh, or browser back/forward.
export const SYNC_MENU_ITEM_ACTION: Action = {
    name: 'SYNC_MENU_ITEM_ACTION',
    action: (item: MainMenu) => ({
        item,
        type: SYNC_MENU_ITEM_ACTION.name
    })
};

export const ON_MOUSE_ENTER_MENU: Action = {
    name: 'ON_MOUSE_ENTER_MENU',
    action: () => ({
        type: ON_MOUSE_ENTER_MENU.name
    })
};

export const ON_MOUSE_LEAVE_MENU: Action = {
    name: 'ON_MOUSE_LEAVE_MENU',
    action: () => ({
        type: ON_MOUSE_LEAVE_MENU.name
    })
};

export const SET_MENU_BY_ROLES_ACTION: Action = {
    name: 'SET_MENU_BY_ROLES_ACTION',
    action: (roles: string[]) => ({
        roles,
        type: SET_MENU_BY_ROLES_ACTION.name
    })
};
